import { RequireKeys } from '@modules/common/typescriptUtils';
import {
  DashboardListItemViewFragment,
  DashboardViewFragment,
  UpdateDashboardMutationVariables,
} from 'generated/graphql';
import { ListUsersItem } from 'v2/core/repository/edge-server/types/listUsers';

export interface ShortMetadata {
  dashboardEmoji?: string;
}

export type UpdateDashboardRequest = Omit<
  UpdateDashboardMutationVariables,
  'tenantID' | 'userID' | 'version'
> &
  Pick<DashboardViewFragment, 'viewToken'> &
  Partial<Pick<UpdateDashboardMutationVariables, 'version'>>;

export type EditableDashboard = RequireKeys<
  DashboardViewFragment,
  'editToken' | 'version'
>;

export type EditableDashboardListItem = RequireKeys<
  DashboardListItemViewFragment,
  'editToken'
>;

export type DashboardCollaborator =
  | (ListUsersItem & { isExisting: true })
  | {
      isExisting: false;
      email: string;
      isValidEmail: boolean;
    };

export type DashboardHeader = {
  name: string;
  emoji: string;
};

export const ScrollSpeed = {
  Fast: 1200,
  Medium: 600,
  Slow: 400,
} as const;

export enum ScrollDirection {
  Up,
  Down,
}

export interface ScrollParams {
  speed: typeof ScrollSpeed[keyof typeof ScrollSpeed];
  direction: ScrollDirection;
}
